// ProfileContext.js
import React, { createContext, useState, useContext } from "react";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState(null);
  const [clientProfileImage, setClientProfileImage] = useState(null);
  
  // NEW: Add Brand Logo and Company Data
  const [brandLogo, setBrandLogo] = useState(null);
  const [companyData, setCompanyData] = useState({
    name: "", website: "", email: "", phone: "",
    street: "", cityState: "", zip: ""
  });

  return (
    <ProfileContext.Provider 
      value={{ 
        profileImage, setProfileImage,
        clientProfileImage, setClientProfileImage,
        brandLogo, setBrandLogo,           // Added
        companyData, setCompanyData        // Added
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);